import { ReactElement } from 'react'

import { Typeahead } from 'components/Typeahead'
import { TypeaheadOption } from 'types'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type FormikTypeaheadProps<V> = FormikWithCustomHandlersProps<V> & {
    onChangeInput(inputValue: string): void
    placeholder: string
}

function FormikTypeahead<V extends TypeaheadOption[] = TypeaheadOption[]>({
    field: { value },
    form,
    handleChange,
    handleBlur,
    handleClick,
    ...props
}: FormikTypeaheadProps<V>): ReactElement {
    return (
        <Typeahead
            values={value}
            onChange={(newValue) => {
                handleClick()
                handleChange(newValue)
            }}
            {...props}
        />
    )
}

export default withCustomHandlers(FormikTypeahead)
